/* eslint-disable  */

import React, { useEffect } from 'react';
import { Form, Input, Table } from 'antd';
import dayjs from 'dayjs';

const EditableMonthTable = ({ totalRows = 0, startMonthStr, formListName, form, numberOfColumn = 3, existingData = null }) => {
	// Ensure startMonth is a valid dayjs object
	const startMonth = startMonthStr ? dayjs(startMonthStr, 'DD-MM-YYYY') : dayjs();

	// console.log('Table props:', { totalRows, startMonthStr, formListName, numberOfColumn });

	// Generate rows data based on totalRows
	// Generate row data with months and periods
	const generateRowsData = () => {
		if (!totalRows || totalRows <= 0) return [];

		return Array.from({ length: parseInt(totalRows) }).map((_, index) => {
			const monthDate = dayjs(startMonth).add(index, 'months');

			// Check if we have existing data to use
			if (existingData && existingData[index]) {
				if (numberOfColumn === 3) {
					return {
						key: `row-${index}`,
						month: monthDate.format('DD-MM-YYYY'),
						period: index + 1,
						value: existingData[index].value || '',
					};
				} else {
					return {
						key: `row-${index}`,
						month: monthDate.format('DD-MM-YYYY'),
						period: index + 1,
						advanceAmount: existingData[index].advanceAmount || '',
						advanceAdjustment: existingData[index].advanceAdjustment || '',
					};
				}
			}

			// Default empty data
			if (numberOfColumn === 3) {
				return {
					key: `row-${index}`,
					month: monthDate.format('DD-MM-YYYY'),
					period: index + 1,
					value: '',
				};
			} else {
				return {
					key: `row-${index}`,
					month: monthDate.format('DD-MM-YYYY'),
					period: index + 1,
					advanceAmount: '',
					advanceAdjustment: '',
				};
			}
		});
	};

	// Initialize form data
	useEffect(() => {
		if (totalRows > 0 && formListName && form) {
			// console.log('Initializing EditableMonthTable with formListName:', formListName);

			// Generate data structure
			const rowData = generateRowsData();

			// Format data for form
			let initialValues;

			if (existingData) {
				// console.log('Using existing data to initialize form:', existingData);
				initialValues = { [formListName]: existingData };
			} else {
				// Create new form data structure
				initialValues = {
					[formListName]: rowData.map((row) => {
						if (numberOfColumn === 3) {
							return { value: '' };
						} else {
							return {
								advanceAmount: '',
								advanceAdjustment: '',
							};
						}
					}),
				};
				// console.log('Creating new form data:', initialValues);
			}

			// Set the form values
			form.setFieldsValue(initialValues);
		}
	}, [totalRows, formListName, form, startMonth, numberOfColumn, existingData]);

	// Define columns based on numberOfColumn
	const getColumns = () => {
		const baseColumns = [
			{
				title: 'Month',
				dataIndex: 'month',
				key: 'month',
				render: (_, __, index) => {
					const monthDate = dayjs(startMonth).add(index, 'months');
					return monthDate.format('DD-MM-YYYY');
				},
			},
			{
				title: 'Period',
				dataIndex: 'period',
				key: 'period',
				render: (_, __, index) => index + 1,
			},
		];

		if (numberOfColumn === 3) {
			return [
				...baseColumns,
				{
					title: 'Gross Rent',
					dataIndex: 'grossRent',
					key: 'grossRent',
					render: (_, field) => (
						<Form.Item name={[field.name, 'value']} noStyle>
							{/* <Input placeholder="Enter value" /> */}
							<Input placeholder="Enter amount" />
						</Form.Item>
					),
				},
			];
		} else {
			return [
				...baseColumns,
				{
					title: 'Advance Amount',
					dataIndex: 'advanceAmount',
					key: 'advanceAmount',
					render: (_, field) => (
						<Form.Item name={[field.name, 'advanceAmount']} noStyle>
							<Input placeholder="Enter amount" />
						</Form.Item>
					),
				},
				{
					title: 'Advance Adjustment',
					dataIndex: 'advanceAdjustment',
					key: 'advanceAdjustment',
					render: (_, field) => (
						<Form.Item name={[field.name, 'advanceAdjustment']} noStyle>
							<Input placeholder="Enter adjustment" />
						</Form.Item>
					),
				},
			];
		}
	};

	// Generate rows data for rendering
	const rowData = generateRowsData();

	return (
		<div>
			{totalRows <= 0 ? (
				<div style={{ textAlign: 'center', padding: '20px' }}>Please set Lease Term and Lease Start Date before opening this modal</div>
			) : (
				<Form form={form}>
					<Form.List name={formListName}>
						{(fields) => {
							// console.log('Form List fields:', fields.length);
							return (
								<Table
									dataSource={fields.length > 0 ? fields : rowData}
									columns={getColumns()}
									pagination={false}
									rowKey={(record) => record.name || record.key}
									bordered
									scroll={{ y: 400 }}
									size="small"
								/>
							);
						}}
					</Form.List>
				</Form>
			)}
		</div>
	);
};

export default EditableMonthTable;
